//#Global Imports
import React from "react";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import Countdown, { zeroPad } from "react-countdown";
//#end Global Imports

//#Local Imports
import Modal from "../../../../components/ui/Modal";
import Button from "../../../../components/ui/Button";
import OtpBox from "../../../../components/ui/OtpBox";
import { IStepOne } from "./StepOne";
// import ErrorField from "../../../../components/ui/ErrorField";
import { getRequestTime, registerUserData, sendOtp, validateOtp } from "../../../../services/auth";
import moment from "moment";
import ErrorField from "../../../../components/ui/ErrorField";
//#end Local Imports

const MasterVendorOtpBoxModal: React.FC<IStepOne.IMasterVendorOtpBoxModalProps> = ({
  isMasterVendorOtpBox,
  setIsMasterVendorOtpBox,
  masterVendorEmail,
  userData,
  setIsRegisteredSuccessful,
}) => {
  const navigate = useNavigate();
  const [otpValue, saveOtpValue] = React.useState<string>("");
  const [otpError, setOTPError] = React.useState<boolean>(false);
  const [isOTPVerified, setOTPVerified] = React.useState<boolean>(false);
  const [verifyOtpError, setVerifyOtpError] = React.useState<string>("");
  const [date, saveDate] = React.useState(Date.now() + 120000);
  const [dateKey, saveDateKey] = React.useState(0);

  const verifyOTP = () => {
    getRequestTime().then((response: any) => {
      const reqTime = response.data.currentTime;
      validateOtp({
        email_phone: masterVendorEmail,
        otp: otpValue,
        otpType: "email",
      })
        .then((response: any) => {
          const responseTime = response?.data?.timeStamp;
          const timeStampDiff = moment(responseTime, "hh:mm:ss").diff(
            moment(reqTime, "hh:mm:ss"),
            "seconds",
          );
          if (response?.data?.success && timeStampDiff <= 10) {
            getRequestTime().then((response: any) => {
              const reqTime = response.data.currentTime;

              setOTPError(false);
              setOTPVerified(true);
              registerUserData({
                email: userData.email,
                password: userData.password,
                is_email_verified: true,
                is_phone_verified: true,
                is_master_verified: true,
                phoneNumber: userData.mobileNumber,
                partnerType: "moneyhop",
                vendor_code: userData.vendorCode,
              })
                .then((res: any) => {
                  const responseTime = res?.data?.timeStamp;
                  const timeStampDiff = moment(responseTime, "hh:mm:ss").diff(
                    moment(reqTime, "hh:mm:ss"),
                    "seconds",
                  );
                  if (res?.data?.isOtpSent && timeStampDiff <= 10) {
                    setIsMasterVendorOtpBox(false);
                    setIsRegisteredSuccessful(true);
                    setTimeout(() => {
                      navigate("/auth/sign-in-new");
                    }, 700);
                  } else if (res?.data?.success) {
                    setIsRegisteredSuccessful(true);
                    setTimeout(() => {
                      navigate("/auth/sign-in-new");
                    }, 700);
                  } else {
                    setIsRegisteredSuccessful(false);
                  }
                })
                .catch((error) => {
                  setOTPVerified(false);
                   setVerifyOtpError(error?.response?.data?.error?.type);
                  setTimeout(() => {
                    setVerifyOtpError("");
                  }, 6000);
                  console.error(error);
                });
            });
          } else if (response?.data?.is_invalid) {
            setOTPError(true);
            setOTPVerified(false);
            setVerifyOtpError(response?.data?.message);
          } else {
            setOTPError(true);
            setOTPVerified(false);
            setVerifyOtpError(response?.response?.data?.error?.type);
          }
        })
        .catch((error) => {
          console.error(error);
          setVerifyOtpError(error?.response?.data?.error?.type);
          setTimeout(() => {
            setVerifyOtpError("");
          }, 6000);
        });
    });
  };

  const resendOTP = () => {
    sendOtp({
      body: {
        phoneNumber: masterVendorEmail,
        otpType: "email",
      },
      apiType: "resend",
    })
      .then(() => {
        saveDate(Date.now() + 120000);
        saveDateKey(dateKey + 1);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  console.log(verifyOtpError, "verifyOtpError");

  return (
    <Modal
      modalClass="!pt-4 md:pr-11 !rounded max-h-[90%] overflow-scroll !w-fit"
      headerClass="mt-2 bg-red sticky py-8 left-8 right-20 -top-6 bg-white font-bold text-2xl"
      visible={isMasterVendorOtpBox}
      closeHandler={() => setIsMasterVendorOtpBox(false)}
    >
      <div className="flex flex-col justify-between w-full h-full items-center">
        <div className="flex flex-col items-center">
          <div className={clsx("mb-9 text-center")}>
            <div className="mb-3 text-base font-semibold text-black font-ssp">Enter OTP</div>
            <div className="text-sm font-normal font-ssp text-grey-550">
              A 6-digit OTP is sent to master vendor email <b>{masterVendorEmail}</b>
            </div>
          </div>
          <div>
            <OtpBox
              updateValue={(value) => saveOtpValue(value)}
              errorMsg={verifyOtpError}
              errorMessageClassname={otpError ? "border-none bg-[transparent] text-center" : ""}
              numberOfBoxes={6}
              otpBoxClassName="!w-[52px]"
            />
          </div>
        </div>
        {/* <div className={clsx(verifyOtpError !== "" ? "flex text-center w-full" : "hideden")}>
          <ErrorField errorMessage={verifyOtpError} />
        </div> */}
        <div
          className={clsx(
            isOTPVerified ? "flex" : "hidden",
            "text-success font-ssp font-medium text-sm mt-7",
          )}
        >
          OTP Verified
        </div>
        <div
          className={clsx(
            otpValue.length >= 1 ? "mt-[26px]" : "mt-[26px]",
            isOTPVerified && "mt-[72px] md:mt-[80px]",
            "flex flex-col items-center sm:justify-center justify-end h-full",
          )}
        >
          <div className={clsx("pb-8")}>
            <Countdown
              key={dateKey}
              date={date}
              renderer={({ minutes, seconds, completed }) => {
                if (completed) {
                  return (
                    <div
                      className="z-10 text-xs font-bold text-black cursor-pointer font-ssp"
                      onClick={resendOTP}
                    >
                      Resend OTP
                    </div>
                  );
                } else {
                  return (
                    <div className="flex items-center space-x-2">
                      <div className="text-xs font-bold text-black font-ssp">Resend OTP</div>
                      <div className={"text-xs font-bold text-primary font-ssp"}>
                        {zeroPad(minutes)} :{zeroPad(seconds)}
                      </div>
                    </div>
                  );
                }
              }}
            />
          </div>
          <div className="flex">
            <Button
              bgColor={`${otpValue.length == 6 ? "bg-primary-1050" : "bg-grey-500"}`}
              fontStyle={{
                fontFamily: "font-ssp",
                fontSize: "text-base",
                fontWeight: "font-medium",
                fontColor: "text-white",
              }}
              borderStyle={{
                borderWidth: "border",
                borderRadius: "rounded",
              }}
              className="w-[220px] h-[54px] z-10"
              disabled={otpValue.length < 6}
              onClickHandler={verifyOTP}
            >
              Verify
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MasterVendorOtpBoxModal;
